module.exports = __webpack_public_path__ + "static/media/duggu.a70eb4ca.jpeg";